export const pick = <T extends {}, K extends keyof T>(obj: T, ...keys: K[]) => (
	Object.fromEntries(
		keys
			.filter(key => key in obj)
			.map(key => [key, obj[key]])
	) as Pick<T, K>
);

export const getKeyByValue = (obj: Record<string, string>, value: string) => 
	Object.keys(obj).find(key => obj[key] === value);

export const toChunks = (chunkAmount: number) => <T>(source: T[]): T[][] => {
	const groups = Math.ceil(source.length / chunkAmount);
	return [...Array(chunkAmount)].map((_, i) => source.slice(i * groups, (i + 1) * groups));
};